import ignoreViewOnNordicPage from '../../../ui-components/ignoreViewOnNordicPage';
import ViewLegacy from '../../../../pages/vip/views/view';

export default ignoreViewOnNordicPage(ViewLegacy);
